var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{key:this.$route.path},[_c('TheHeader',{attrs:{"hasHeaderBackground":this.$route.path === '/' ? false : true}}),_c('router-view'),_c('TheFooter',{attrs:{"isBackgroundWhite":this.$route.path === '/' ? true : false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }